/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { subsetDependencies } from './dependenciesSubset.generated';
import { createAccessorNode } from '../../factoriesAny.js';
export var AccessorNodeDependencies = {
  NodeDependencies: NodeDependencies,
  subsetDependencies: subsetDependencies,
  createAccessorNode: createAccessorNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAccessorNode.generated.js
// module id = 484
// module chunks = 0